import { jsonInstance, xUrlEncodedInstance } from "./Api";
import TokenService from "./Token.service";

class AuthService {

  async logout(data) {
    const response = await jsonInstance.post("/logout", data);
    TokenService.removeUser();
    return response;
  }


  getCurrentUser() {
    return TokenService.getUser();
  }

  isAuthenticated() {
    return TokenService.checkAuthenticated();
  }

  getRole() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user?.access) {
      return "Role not found";
    } else {
      return user?.access;
    }
  }
  getCompany() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user?.company) {
      return "No Company Found";
    } else {
      return user?.company;
    }
  }

  getCompanyId() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user?.companyId) {
      return "No Company Id Found";
    } else {
      return user?.companyId;
    }
  }
  login(data) {
    return jsonInstance.post("/login", data);
  }
  getUserRoles(data) {
    return jsonInstance.post("/options/user-roles", data);
  }
  createUser(data) {
    return jsonInstance.post("/create-user", data);
  }
  createAgentLogin(data) {
    return jsonInstance.post("/users/create-agent-login", data);
  }
  addNewCompany(data) {
    return jsonInstance.post("/admin/create-company", data);
  }
  getCompanyList(data, params) {
    return jsonInstance.get(
      "/admin/company-list", data, { params });
  }
  updateCompany(templateId, data) {
    return jsonInstance.put(`/admin/update-company/${templateId}`, data);
  }
   updateCampaign(templateId, data) {
    return jsonInstance.put(`/admin/update-campaign/${templateId}`, data);
  }
  getPermissions() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user?.permissions) {
      return [];
    } else {
      return user?.permissions;
    }
  }
  getUserList(data, params) {
    return jsonInstance.post(
      "/get-users", data, { params });
  }
  getAgentList(params) {
    return jsonInstance.get("/users/agent-list", { params });
  }
  updateAgent(data) {
    return jsonInstance.put("/users/update-agent", data);
  }
  deleteAgent(agentId) {
    return jsonInstance.delete(`/users/delete-agent/${agentId}`);
  }
  deleteUser(userId) {
    return jsonInstance.post(`/delete-user/${userId}`);
  }

  resetPassword(userId, data) {
    return jsonInstance.post(`/reset-password/${userId}`, data);
  }
  getLogHistory(data, params) {
    return jsonInstance.post(
      "/get-logs", data, { params });
  }
  makeTestCall(data) {
    return jsonInstance.post("/dialer/test-call", data);
  }
  createNewCampaign(data) {
    return jsonInstance.post("/admin/create-campaign", data);
  }
  deleteCompany(id) {
    return jsonInstance.delete(`/admin/delete-company/${id}`);
  }
  deleteCampaign(id) {
    return jsonInstance.delete(`/admin/delete-campaign/${id}`);
  }
  deleteScript(id) {
    return jsonInstance.delete(`/admin/delete-script/${id}`);
  }
  getCampaignById(id) {
    return jsonInstance.get(`/admin/get-campaign/${id}`);
  }
   getCallNumberOptions(data) {
    return jsonInstance.get("/admin/filtered-numbers",data);
  }
  updateCallNumber(id,data) {
    return jsonInstance.put(`/admin/update-number/${id}`,data);
  }
  deleteCallNumber(id) {
    return jsonInstance.delete(`/admin/delete-number/${id}`);
  }
  addCallNumber(data) {
    return jsonInstance.post("/admin/create-numbers",data);
  }
  getCallNumberList(data) {
    return jsonInstance.get("/admin/numbers-list",data);
  }
  
  updateAgentAssistService(id,data) {
    return jsonInstance.put(`/admin/update-service/${id}`,data);
  }
  deleteAgentAssistService(id) {
    return jsonInstance.delete(`/admin/delete-service/${id}`);
  }
  addAgentAssistService(data) {
    return jsonInstance.post("/admin/create-agent-assist-service",data);
  }
  getAgentAssistServiceList(params) {
    return jsonInstance.get("/admin/agent-assist-service-list",{ params });
  }
   updateDisposition(id,data) {
    return jsonInstance.put(`/admin/update-disposition/${id}`,data);
  }
  deleteDisposition(id) {
    return jsonInstance.delete(`/admin/delete-disposition/${id}`);
  }
  addDisposition(data) {
    return jsonInstance.post("/admin/create-disposition",data);
  }
  getDispositionList(params) {
    return jsonInstance.get("/admin/disposition-list",{ params });
  }
  // 
  createNewScript(data) {
    return jsonInstance.post("/admin/create-scripts",data);
  }
  getScriptList(params) {
    return jsonInstance.get("/admin/script-list", { params });
  }
  updateScript(id,data){
    return jsonInstance.put(`/admin/update-script/${id}`,data);
  }
  getScriptById(id) {
    return jsonInstance.get(`/admin/get-script/${id}`);
  }
  updateUnassignedNumber(id) {
    return jsonInstance.put(`/admin/unassign-number/${id}`);
  }
  getNumberKeys(id) {
    return jsonInstance.get(`/admin/get-number/${id}`);
  }

 
}

export default new AuthService();
